import React, { useState } from 'react';
import '../styles/I3Testimonials.css';

const TESTIMONIALS = [
  {
    quote:
      'Lisa helped us find our way back to each other. We learned to listen again—and to mean it when we said we were sorry.',
    initials: 'M.K.',
    role: 'Couples Counseling',
  },
  {
    quote:
      'I came in carrying so much anxiety. Session by session, I felt lighter—and more like myself than I had in years.',
    initials: 'S.R.',
    role: 'Individual Therapy',
  },
  {
    quote:
      'Our family finally has tools that work at home, not just in the office. The calm has been worth every step.',
    initials: 'J. & T.',
    role: 'Family Counseling',
  },
] as const;

const StarRow: React.FC = () => (
  <div className="i3-testimonial-stars" aria-label="5 out of 5 stars">
    {Array.from({ length: 5 }).map((_, i) => (
      <span key={i} className="i3-testimonial-star" aria-hidden>
        ★
      </span>
    ))}
  </div>
);

const I3TestimonialsCarousel: React.FC = () => {
  const [index, setIndex] = useState(0);
  const count = TESTIMONIALS.length;

  const prev = () => setIndex((i) => (i - 1 + count) % count);
  const next = () => setIndex((i) => (i + 1) % count);

  return (
    <section className="i3-kind-words i3-home-section-bleed" aria-labelledby="i3-kind-words-title">
      <h2 id="i3-kind-words-title" className="i3-kind-words-title">
        Kind Words
      </h2>
      <div className="i3-testimonial-carousel">
        <button type="button" className="i3-testimonial-nav i3-testimonial-nav--prev" onClick={prev} aria-label="Previous testimonial">
          ‹
        </button>
        <div className="i3-testimonial-track">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.initials}
              className={`i3-testimonial-card-mockup${i === index ? ' i3-testimonial-card-mockup--active' : ''}`}
              aria-hidden={i !== index}
            >
              <blockquote className="i3-testimonial-card-mockup-quote">
                <p>&ldquo;{t.quote}&rdquo;</p>
              </blockquote>
              <footer className="i3-testimonial-card-mockup-footer">
                <cite className="i3-testimonial-card-mockup-cite">{t.initials}</cite>
                <span className="i3-testimonial-card-mockup-role">{t.role}</span>
                <StarRow />
              </footer>
            </article>
          ))}
        </div>
        <button type="button" className="i3-testimonial-nav i3-testimonial-nav--next" onClick={next} aria-label="Next testimonial">
          ›
        </button>
      </div>
      <div className="i3-testimonial-dots" role="tablist" aria-label="Testimonial slides">
        {TESTIMONIALS.map((t, i) => (
          <button
            key={t.initials}
            type="button"
            role="tab"
            aria-selected={i === index}
            aria-label={`Testimonial ${i + 1}`}
            className={`i3-testimonial-dot${i === index ? ' i3-testimonial-dot--active' : ''}`}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </section>
  );
};

export default I3TestimonialsCarousel;
